import * as actionTypes from "./actionTypes";

//eslint-disable-next-line

import Axios from "axios";
import { apiStart, apiSuccess } from "./apiActions";
import { errorHandler, catchHandler, successHandler } from "./responseHandler";
import * as urls from "../../utils/urls";
import { getUserData } from "../../utils/localStorage";

import format from "date-fns/format";
import { getDoctorDetails } from "./physicianOnboardingActions";

import {
  parseDateToLocal,
  parseDateToUTC,
  parseTimeToLocal,
  parseDateToLocalWithTime,
  parseTimeToUTC,
  getUTCDateTime,
  parseTimeToUTCSS,
  parseDateInWithTime,
} from "../../utils/parseDateTime";
import messages from "../../constants/messages";
import moment from "moment";

export const setChangePassword = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_CHANGE_PASSWORD,
      payload,
    });
};

export const clearChangePassword = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.CLEAR_CHANGE_PASSWORD,
      payload,
    });
};

export const setAvailabilitySchedule = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_AVAILABILITY_SCHEDULE,
      payload,
    });
};

export const setUnavailabilitySchedule = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_UNAVAILABILITY_SCHEDULE,
      payload,
    });
};

export const setPatients = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_PATIENTS,
      payload,
    });
};

export const setClearMessageNotificationDot = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_CLEAR_MESSSAGE_NOTIFICATION_DOT,
      payload,
    });
};

export const setChatMessagesCount = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_CHAT_MESSAGES_COUNT,
      payload,
    });
};

export const setActivePatientsCount = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_ACTIVE_PATIENT_SUBSCRIPTION_COUNT,
      payload,
    });
};

export const setConciergeServiceStatus = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_CONCIERGE_SERVICE_STATUS,
      payload,
    });
};

export const searchPatient = payload => {
  return (dispatch, getState) => {
    const patients = getState()?.dashboard?.patients;
  
    const fetchedPatients =
      payload === "allPatients"
        ? patients?.allPatients
        : patients?.myPatients;
    
    const searchedMyPatients = fetchedPatients .filter(
      patient =>
        patient.first_name
          ?.toLowerCase()
          ?.includes(payload?.toLowerCase()) ||
        patient.last_name
          ?.toLowerCase()
          ?.includes(payload?.toLowerCase())
    );
    
    dispatch(setPatients({ ...payload, searchedMyPatients }));
    dispatch({
      type: actionTypes.SEARCH_PATIENT,
      searchValue: payload,
      search: searchedMyPatients,
      total_pages: 1,
    });
  };
};   
    
    
  

export const changeControl = control => {
  return dispatch =>
    dispatch({
      type: actionTypes.CHANGE_CONTROL,
      control,
    });
};

export const clearControl = control => {
  return dispatch =>
    dispatch({
      type: actionTypes.CLEAR_CONTROL,
      control,
    });
};

export const setSubscribedConciergeServiceList = data => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_SUBSCRIBED_CONCIERGE_SERVICE_LIST,
      data,
    });
};

export const changePassword = () => {
  return (dispatch, getState) => {
    const changePassword = getState().changePassword;

    const payload = {
      old_password: changePassword.oldPassword,
      new_password: changePassword.resetPassword,
    };

    dispatch(apiStart());
    Axios.put(urls.changePasswordUrl(), payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(
            setChangePassword({
              oldPassword: undefined,
              resetPassword: undefined,
              resetConfirmPassword: undefined,
            })
          );
          successHandler(res.message[0]);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const parseTime = (hour, minutes) => {
  return parseInt(hour) * 60 + parseInt(minutes);
};

export const convertHours = mins => {
  var hour = Math.floor(mins / 60);
  var minutes = mins % 60;
  var converted = pad(hour, 2) + ":" + pad(minutes, 2);
  return converted;
};

export const pad = (str, max) => {
  str = str.toString();
  return str.length < max ? pad("0" + str, max) : str;
};

export const calculate_time_slot = (
  start_time,
  end_time,
  interval = "20",
  obj,
  selected_date,
  stat
) => {
  console.log(obj, "obj");
  var formatted_time;
  var time_slots = [];
  let some_prevoius_final_array = [];

  let utc_end_time = moment(
    selected_date + " " + obj?.endTime?.hour + ":" + obj?.endTime.minutes
  )
    .utc()
    .format("YYYY-MM-DD");

  let utc_start_time = moment(
    selected_date + " " + obj?.startTime?.hour + ":" + obj?.startTime?.minutes
  )
    .utc()
    .format("YYYY-MM-DD");

  let local_start_time = moment(
    selected_date + " " + obj?.startTime?.hour + ":" + obj?.startTime?.minutes
  ).format("YYYY-MM-DD");

  let local_end_time = moment(
    selected_date + " " + obj?.endTime?.hour + ":" + obj?.endTime?.minutes
  ).format("YYYY-MM-DD");

  let time_cal = (end_time - start_time) / 60000;

  if (Math.sign(time_cal) === -1) {
    let new_start_time = "00";

    if (stat == -1 || stat == 0) {
      for (var i = end_time; i > new_start_time; i = i - interval) {
        formatted_time = convertHours(i);
        // if (formatted_time >= new_start_time + ":" + interval)
        time_slots.push(formatted_time);
        const converted_date = parseDateInWithTime(
          formatted_time,
          moment(selected_date).format("YYYY-MM-DD")
        );
        if (moment(selected_date).format("YYYY-MM-DD") == converted_date) {
          some_prevoius_final_array.push(formatted_time);
        }
      }
    }

    let new_end_time = 1440;
    if (stat == 1 || stat == 0 || stat == -1) {
      if (utc_end_time > utc_start_time || local_start_time == utc_start_time) {
        for (var i = start_time; i <= new_end_time; i = i + interval) {
          formatted_time = convertHours(i);
          time_slots.push(formatted_time);
          const converted_date = parseDateInWithTime(
            formatted_time,
            moment(selected_date).format("YYYY-MM-DD")
          );

          if (moment(selected_date).format("YYYY-MM-DD") == converted_date) {
            some_prevoius_final_array.push(formatted_time);
          }
        }
      }
    }
  } else {
    if (stat == -1 || stat == 0) {
      for (var i = start_time; i <= end_time - interval; i = i + interval) {
        formatted_time = convertHours(i);
        time_slots.push(formatted_time);
        const converted_date = parseDateInWithTime(
          formatted_time,
          moment(selected_date).format("YYYY-MM-DD")
        );
        if (moment(selected_date).format("YYYY-MM-DD") == converted_date) {
          some_prevoius_final_array.push(formatted_time);
        }
      }
    }
  }
  console.log(some_prevoius_final_array, "some_prevoius_final_array");
  return some_prevoius_final_array;
};

const slotDevidationFunction = (
  slot,
  availabilitySchedule,
  sltTimezone,
  selectedDate
) => {
  let dateSlot = availabilitySchedule?.scheduledDate;
  const prevoius_date =
    new Date(dateSlot - 86400000) || new Date(dateSlot - 86400000);
  
  const next_date =
    new Date(dateSlot?.getTime() + 24 * 60 * 60 * 1000) ||
    new Date(new Date().getTime() + 24 * 60 * 60 * 1000);

  let slotObject;
  let previousStat = -1;
  let currentStat = 0;
  let nextStat = 1;
  const previousMorningSlotUpdated = [];
  const previousAfternoonSlotUpdated = [];
  const previousEveningSlotUpdated = [];
  const currentMorningSlotUpdated = [];
  const currentAfternoonSlotUpdated = [];
  const currentEveningSlotUpdated = [];
  const futureMorningSlotUpdated = [];
  const futureAfternoonSlotUpdated = [];
  const futureEveningSlotUpdated = [];
  let previousSlotObjectUpdated = {};
  let currentSlotObjectUpdated;
  let futureSlotObjectUpdated;
  const previousLatestSlotArray = [];
  const currentLatestSlotArray = [];
  const futureLatestSlotArray = [];

  // Previous List Slot
  if (prevoius_date >= slot.startDate && prevoius_date <= slot.endDate) {
    if (slot?.workingDays.includes(prevoius_date.getDay() + 1)) {
      slot?.morningSlots.forEach(morningSlot => {
        var start_time = parseTime(
            morningSlot.startTime.hour,
            morningSlot.startTime.minutes
          ),
          end_time = parseTime(
            morningSlot.endTime.hour,
            morningSlot.endTime.minutes
          ),
          interval = morningSlot?.duration.value;

        var morningTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          morningSlot,
          prevoius_date,
          previousStat
        );

        slotObject = {
          ...slotObject,
          morningSlots: slotObject?.morningSlots
            ? [...slotObject?.morningSlots, ...morningTimes]
            : morningTimes,
        };
      });

      slot?.afternoonSlots?.forEach(afternoonSlot => {
        var start_time = parseTime(
            afternoonSlot.startTime.hour,
            afternoonSlot.startTime.minutes
          ),
          end_time = parseTime(
            afternoonSlot.endTime.hour,
            afternoonSlot.endTime.minutes
          ),
          interval = afternoonSlot?.duration.value;

        var afternoonTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          afternoonSlot,
          prevoius_date,
          previousStat
        );

        slotObject = {
          ...slotObject,
          afternoonSlots: slotObject?.afternoonSlots
            ? [...slotObject?.afternoonSlots, ...afternoonTimes]
            : afternoonTimes,
        };
      });

      slot?.eveningSlots?.forEach(eveningSlot => {
        var start_time = parseTime(
            eveningSlot.startTime.hour,
            eveningSlot.startTime.minutes
          ),
          end_time = parseTime(
            eveningSlot.endTime.hour,
            eveningSlot.endTime.minutes
          ),
          interval = eveningSlot?.duration.value;

        var eveningTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          eveningSlot,
          prevoius_date,
          previousStat
        );

        slotObject = {
          ...slotObject,
          eveningSlots: slotObject?.eveningSlots
            ? [...slotObject?.eveningSlots, ...eveningTimes]
            : eveningTimes,
        };
      });
      console.log(slotObject, "slotObject");

      if (
        slotObject?.morningSlots != undefined &&
        slotObject?.morningSlots?.length > 0
      ) {
        previousLatestSlotArray.push(...slotObject?.morningSlots);
      }
      if (
        slotObject?.afternoonSlots != undefined &&
        slotObject?.afternoonSlots?.length > 0
      ) {
        previousLatestSlotArray.push(...slotObject?.afternoonSlots);
      }

      if (
        slotObject?.eveningSlots != undefined &&
        slotObject?.eveningSlots?.length > 0
      ) {
        previousLatestSlotArray.push(...slotObject?.eveningSlots);
      }

      previousLatestSlotArray.forEach(x => {
        if (x >= "00:00" && x <= "11:59") {
          previousMorningSlotUpdated.push(x);
        } else if ((x > "12:00" || x == "12:00") && x <= "17:59") {
          previousAfternoonSlotUpdated.push(x);
        } else {
          previousEveningSlotUpdated.push(x);
        }
      });

      previousSlotObjectUpdated = {
        previousMorningSlots: [...new Set(previousMorningSlotUpdated)].sort(),
        previousAfternoonSlots: [
          ...new Set(previousAfternoonSlotUpdated),
        ].sort(),
        previousEveningSlots: [...new Set(previousEveningSlotUpdated)].sort(),
      };
    }
  }

  // Current Date Slot
  if (dateSlot >= slot.startDate && dateSlot <= slot.endDate) {
    if (slot?.workingDays.includes(dateSlot.getDay() + 1)) {
      slot?.morningSlots.forEach(morningSlot => {
        var start_time = parseTime(
            morningSlot.startTime.hour,
            morningSlot.startTime.minutes
          ),
          end_time = parseTime(
            morningSlot.endTime.hour,
            morningSlot.endTime.minutes
          ),
          interval = morningSlot?.duration.value;

        var morningTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          morningSlot,
          dateSlot,
          currentStat
        );

        slotObject = {
          ...slotObject,
          morningSlots: slotObject?.morningSlots
            ? [...slotObject?.morningSlots, ...morningTimes]
            : morningTimes,
        };
      });

      slot?.afternoonSlots?.forEach(afternoonSlot => {
        var start_time = parseTime(
            afternoonSlot.startTime.hour,
            afternoonSlot.startTime.minutes
          ),
          end_time = parseTime(
            afternoonSlot.endTime.hour,
            afternoonSlot.endTime.minutes
          ),
          interval = afternoonSlot?.duration.value;

        var afternoonTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          afternoonSlot,
          dateSlot,
          currentStat
        );

        slotObject = {
          ...slotObject,
          afternoonSlots: slotObject?.afternoonSlots
            ? [...slotObject?.afternoonSlots, ...afternoonTimes]
            : afternoonTimes,
        };
      });

      slot?.eveningSlots?.forEach(eveningSlot => {
        var start_time = parseTime(
            eveningSlot.startTime.hour,
            eveningSlot.startTime.minutes
          ),
          end_time = parseTime(
            eveningSlot.endTime.hour,
            eveningSlot.endTime.minutes
          ),
          interval = eveningSlot?.duration.value;

        var eveningTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          eveningSlot,
          dateSlot,
          currentStat
        );

        slotObject = {
          ...slotObject,
          eveningSlots: slotObject?.eveningSlots
            ? [...slotObject?.eveningSlots, ...eveningTimes]
            : eveningTimes,
        };
      });

      if (
        slotObject?.morningSlots != undefined &&
        slotObject?.morningSlots?.length > 0
      ) {
        currentLatestSlotArray.push(...slotObject?.morningSlots);
      }
      if (
        slotObject?.afternoonSlots != undefined &&
        slotObject?.afternoonSlots?.length > 0
      ) {
        currentLatestSlotArray.push(...slotObject?.afternoonSlots);
      }

      if (
        slotObject?.eveningSlots != undefined &&
        slotObject?.eveningSlots?.length > 0
      ) {
        currentLatestSlotArray.push(...slotObject?.eveningSlots);
      }

      currentLatestSlotArray.forEach(x => {
        if (x >= "00:00" && x <= "11:59") {
          currentMorningSlotUpdated.push(x);
        } else if ((x > "12:00" || x == "12:00") && x <= "17:59") {
          currentAfternoonSlotUpdated.push(x);
        } else {
          currentEveningSlotUpdated.push(x);
        }
      });

      currentSlotObjectUpdated = {
        currentMorningSlots: [...new Set(currentMorningSlotUpdated)].sort(),
        currentAfternoonSlots: [...new Set(currentAfternoonSlotUpdated)].sort(),
        currentEveningSlots: [...new Set(currentEveningSlotUpdated)].sort(),
      };
    }
  }

  // Next Date Slot

  if (next_date >= slot.startDate && next_date <= slot.endDate) {
    if (slot?.workingDays.includes(next_date.getDay() + 1)) {
      slot?.morningSlots.forEach(morningSlot => {
        var start_time = parseTime(
            morningSlot.startTime.hour,
            morningSlot.startTime.minutes
          ),
          end_time = parseTime(
            morningSlot.endTime.hour,
            morningSlot.endTime.minutes
          ),
          interval = morningSlot?.duration.value;

        var morningTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          morningSlot,
          next_date,
          nextStat
        );

        slotObject = {
          ...slotObject,
          morningSlots: slotObject?.morningSlots
            ? [...slotObject?.morningSlots, ...morningTimes]
            : morningTimes,
        };
      });

      slot?.afternoonSlots?.forEach(afternoonSlot => {
        var start_time = parseTime(
            afternoonSlot.startTime.hour,
            afternoonSlot.startTime.minutes
          ),
          end_time = parseTime(
            afternoonSlot.endTime.hour,
            afternoonSlot.endTime.minutes
          ),
          interval = afternoonSlot?.duration.value;

        var afternoonTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          afternoonSlot,
          next_date,
          nextStat
        );

        slotObject = {
          ...slotObject,
          afternoonSlots: slotObject?.afternoonSlots
            ? [...slotObject?.afternoonSlots, ...afternoonTimes]
            : afternoonTimes,
        };
      });

      slot?.eveningSlots?.forEach(eveningSlot => {
        var start_time = parseTime(
            eveningSlot.startTime.hour,
            eveningSlot.startTime.minutes
          ),
          end_time = parseTime(
            eveningSlot.endTime.hour,
            eveningSlot.endTime.minutes
          ),
          interval = eveningSlot?.duration.value;

        var eveningTimes = calculate_time_slot(
          start_time,
          end_time,
          interval,
          eveningSlot,
          next_date,
          nextStat
        );

        slotObject = {
          ...slotObject,
          eveningSlots: slotObject?.eveningSlots
            ? [...slotObject?.eveningSlots, ...eveningTimes]
            : eveningTimes,
        };
      });

      if (
        slotObject?.morningSlots != undefined &&
        slotObject?.morningSlots?.length > 0
      ) {
        futureLatestSlotArray.push(...slotObject?.morningSlots);
      }
      if (
        slotObject?.afternoonSlots != undefined &&
        slotObject?.afternoonSlots?.length > 0
      ) {
        futureLatestSlotArray.push(...slotObject?.afternoonSlots);
      }

      if (
        slotObject?.eveningSlots != undefined &&
        slotObject?.eveningSlots?.length > 0
      ) {
        futureLatestSlotArray.push(...slotObject?.eveningSlots);
      }

      futureLatestSlotArray.forEach(x => {
        if (x >= "00:00" && x <= "11:59") {
          futureMorningSlotUpdated.push(x);
        } else if ((x > "12:00" || x == "12:00") && x <= "17:59") {
          futureAfternoonSlotUpdated.push(x);
        } else {
          futureEveningSlotUpdated.push(x);
        }
      });

      futureSlotObjectUpdated = {
        futureMorningSlots: [...new Set(futureMorningSlotUpdated)].sort(),
        futureAfternoonSlots: [...new Set(futureAfternoonSlotUpdated)].sort(),
        futureEveningSlots: [...new Set(futureEveningSlotUpdated)].sort(),
      };
    }
  }

  let slotObjectUpdated;
  slotObjectUpdated = {};
  let morningSlotUpdated = [];
  let afternoonSlotUpdated = [];
  let eveningSlotUpdated = [];

  if (sltTimezone == Intl.DateTimeFormat().resolvedOptions().timeZone) {
    morningSlotUpdated = currentSlotObjectUpdated?.currentMorningSlots;
    eveningSlotUpdated = currentSlotObjectUpdated?.currentEveningSlots;
  } else {
    if (Intl.DateTimeFormat().resolvedOptions().timeZone == "Asia/Calcutta") {
      morningSlotUpdated = previousSlotObjectUpdated?.previousMorningSlots;
      eveningSlotUpdated = currentSlotObjectUpdated?.currentEveningSlots;
    } else {
      morningSlotUpdated = currentSlotObjectUpdated?.currentMorningSlots;
      eveningSlotUpdated = futureSlotObjectUpdated?.futureEveningSlots;
    }
    // Will remove once testing is done

    // if (
    //   sltTimezone != Intl.DateTimeFormat().resolvedOptions().timeZone &&
    //   new Date(
    //     selectedDate.toLocaleString("en", {
    //       timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    //     })
    //   ) < new Date(new Date().toLocaleString("en", { timeZone: sltTimezone }))
    // ) {
    //   morningSlotUpdated = currentSlotObjectUpdated?.currentMorningSlots;
    // } else {

    // }
  }

  slotObjectUpdated = {
    morningSlots: [...new Set(morningSlotUpdated)].sort(),
    afternoonSlots: [
      ...new Set(currentSlotObjectUpdated?.currentAfternoonSlots),
    ].sort(),
    eveningSlots: [...new Set(eveningSlotUpdated)].sort(),
  };

  return slotObjectUpdated;
};

export const getSlots = () => {
  return (dispatch, getState) => {
    const practiceDetails = getState().onboarding.practiceDetails;
    const availabilitySchedule = getState().dashboard.availabilitySchedule;
  
    const selectedDate = parseDateToLocal(
      format(availabilitySchedule?.scheduledDate || new Date(), "yyyy-MM-dd")
    );

    const slot_timezone = practiceDetails.slotTimezone;

    const doctorAvailability = practiceDetails.calendar;

    const unavailableSlots = [];

    let notAvailableEntireDay = false;
    let slotObjectUpdated;

    doctorAvailability?.forEach(slot => {
      slotObjectUpdated = slotDevidationFunction(
        slot,
        availabilitySchedule,
        slot_timezone,
        selectedDate
      );
    });
    let doctor_unavailability_updated=practiceDetails.doctorUnavailabilityUpdated;
    let schedule_id = undefined;
    let date_selected=moment(availabilitySchedule?.scheduledDate).format("YYYY-MM-DD")
    let morningSlots = 0;
    let afternoonSlots = 0;
    let eveningSlots = 0;
  
    var unavailability_on_date  = doctor_unavailability_updated?.filter(function (el) {
      return el.slot_date==date_selected
    });

    unavailability_on_date?.forEach(unavailable => {
      const padOut = parseTimeToLocal(
        unavailable.slot_time,
        unavailable.slot_date
      );

      if (slotObjectUpdated?.morningSlots?.includes(padOut))
        morningSlots = morningSlots + 1;
      else if (slotObjectUpdated?.afternoonSlots?.includes(padOut))
        afternoonSlots = afternoonSlots + 1;
      else if (slotObjectUpdated?.eveningSlots?.includes(padOut))
        eveningSlots = eveningSlots + 1;

      unavailableSlots.push(padOut);
    });

    practiceDetails?.doctorUnavailability?.forEach(unavailability => {
      const unavailabilityStartDate = new Date(
        parseDateToLocal(unavailability.start_date)
      ).getTime();

      if (
        unavailability.end_date
          ? selectedDate >= parseDateToLocal(unavailability.start_date) &&
            selectedDate <= parseDateToLocal(unavailability.end_date)
          : selectedDate.getTime() === unavailabilityStartDate
      ) {
        schedule_id = unavailability?.id;

        const extractedSlots = [];

        Object.keys(slotObjectUpdated).map(slot =>
          extractedSlots.push(...slotObjectUpdated[slot])
        );

        if (
          unavailability?.slot_time &&
          unavailability?.slot_time
            .map(slt => parseTimeToLocal(slt, unavailability.start_date))
            .sort()
            .toString() === extractedSlots.sort().toString()
        ) {
          notAvailableEntireDay = true;
        }
      }
    });

    const engagedSlots = [];

    practiceDetails?.engagedSlots?.forEach(engaged => {
      const converted_slots_date = parseDateToLocalWithTime(
        engaged.slot_time,
        engaged?.appointment_date
      );

      if (
        selectedDate.getTime() ===
        parseDateToLocal(converted_slots_date).getTime()
      ) {
        const padOut = parseTimeToLocal(
          engaged.slot_time,
          engaged?.appointment_date
        );
        engagedSlots.push(padOut);
      }
    });

    dispatch(
      setAvailabilitySchedule({
        slots: slotObjectUpdated,
        unavailable_slots: unavailableSlots,
        engaged_slots: engagedSlots,
        notAvailableEntireDay,
        schedule_id,
        count: {
          morningCount: pad(morningSlots.toString(), 2),
          afternoonCount: pad(afternoonSlots.toString(), 2),
          eveningCount: pad(eveningSlots.toString(), 2),
        },
      })
    );
  };
};

export const saveAvailabilitySchedule = () => {
  return (dispatch, getState) => {
    const availabilitySchedule = getState()?.dashboard?.availabilitySchedule;

    dispatch(apiStart());

    const slots = [];

    Object.keys(availabilitySchedule?.slots).map(slot =>
      slots.push(...availabilitySchedule?.slots[slot])
    );

    const formattedSlots = [];

    slots?.map(slt =>
      formattedSlots.push(
        parseTimeToUTC({
          hour: parseInt(slt.split(":")[0]),
          minutes: parseInt(slt.split(":")[1]),
        })
      )
    );

    const unavailableSlots = [];

    availabilitySchedule.unavailable_slots?.map(slt =>
      unavailableSlots.push(
        parseTimeToUTC({
          hour: parseInt(slt.split(":")[0]),
          minutes: parseInt(slt.split(":")[1]),
        })
      )
    );

    const slot_date_detail = [];

    if (!availabilitySchedule.notAvailableEntireDay) {
      availabilitySchedule?.unavailable_slots?.map(slt_dt => {
        slot_date_detail.push({
          slot_time: parseTimeToUTCSS({
            hour: parseInt(slt_dt.split(":")[0]),
            minutes: parseInt(slt_dt.split(":")[1]),
          }),
          slot_date: getUTCDateTime(
            format(
              availabilitySchedule?.scheduledDate || new Date(),
              "yyyy-MM-dd"
            ),
            slt_dt
          ),
        });
      });
    }

    console.log(slot_date_detail, "slot_date_detail");

    if (!availabilitySchedule.schedule_id) {
      const payload = {
        doctor_detail: getUserData().id,
        start_date: parseDateToUTC(
          availabilitySchedule.scheduledDate || new Date()
        ),
        end_date: availabilitySchedule.notAvailableEntireDay
          ? parseDateToUTC(availabilitySchedule.scheduledDate || new Date())
          : null,
        slot_time: !availabilitySchedule.notAvailableEntireDay
          ? unavailableSlots
          : formattedSlots,
        slot_date_detail: slot_date_detail,
      };

      Axios.post(urls.addDoctorUnavailabilityUrl(), payload)
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            dispatch(getDoctorDetails());
            dispatch(
              setAvailabilitySchedule({
                schedule_id: res.data.id,
              })
            );
            successHandler(messages.AVAILABILITY_SCHEDULE_SUCCESS);
          } else {
            errorHandler(res.message[0]);
          }
          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    } else if (
      availabilitySchedule.schedule_id &&
      (availabilitySchedule.notAvailableEntireDay ||
        unavailableSlots.length > 0)
    ) {
      const payload = {
        doctor_detail: getUserData().id,
        start_date: parseDateToUTC(
          availabilitySchedule.scheduledDate || new Date()
        ),
        end_date: availabilitySchedule.notAvailableEntireDay
          ? parseDateToUTC(availabilitySchedule.scheduledDate || new Date())
          : null,
        slot_time: !availabilitySchedule.notAvailableEntireDay
          ? unavailableSlots
          : formattedSlots,
        slot_date_detail: slot_date_detail,
      };
      Axios.patch(
        urls.updateDoctorUnavailabilityUrl(availabilitySchedule.schedule_id),
        payload
      )
        .then(response => {
          const res = response.data;
          if (res.status_code === 200) {
            dispatch(getDoctorDetails());
            successHandler(messages.AVAILABILITY_SCHEDULE_SUCCESS);
          } else {
            errorHandler(res.message[0]);
          }
          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    } else if (
      availabilitySchedule.schedule_id &&
      !availabilitySchedule.notAvailableEntireDay &&
      unavailableSlots.length === 0
    ) {
      const payload = {
        doctor_detail: getUserData().id,
        start_date: parseDateToUTC(
          availabilitySchedule.scheduledDate || new Date()
        ),
        end_date: availabilitySchedule.notAvailableEntireDay
          ? parseDateToUTC(availabilitySchedule.scheduledDate || new Date())
          : null,
        slot_time: !availabilitySchedule.notAvailableEntireDay
          ? unavailableSlots
          : formattedSlots,
      };
      Axios.delete(
        urls.deleteDoctorUnavailabilityUrl(availabilitySchedule.schedule_id),
        payload
      )
        .then(response => {
          const res = response.data;
          if (res.status_code === 204) {
            dispatch(
              setAvailabilitySchedule({
                schedule_id: undefined,
              })
            );
            dispatch(getDoctorDetails());
            successHandler(messages.AVAILABILITY_SCHEDULE_SUCCESS);
          }
          dispatch(apiSuccess());
        })
        .catch(error => {
          catchHandler(error, dispatch);
        });
    }
  };
};


export const getSubscribedConciergeServiceListAction = (search="", requestStatus="ACCEPTED", page=1) => {
  return (dispatch, getState) => {

    dispatch(apiStart());
    Axios.get(urls.getSubscribedConciergeServicePatientListUrl(search, requestStatus, page))
    .then(res => {
      console.log(res);
      dispatch(setSubscribedConciergeServiceList(res?.data?.data[0]))
    }).catch(err => {
      console.log(err);
    }).finally(res => {
      dispatch(apiSuccess(res?.data?.message[0]))
    })
  }
};

export const getChatMessagesCountAction = () => {
  return (dispatch, getState) => {
    Axios.get(urls.getReceivedMessagesCountUrl())
    .then(res => {
      console.log(res);
      dispatch(setChatMessagesCount(res?.data))
    }).catch(err => {
      console.log(err);
    }).finally(res => {
    })
  }
};

export const getActivePatientSubscriptionCountAction = () => {
  return (dispatch, getState) => {
    Axios.get(urls.getActivePatientSubscriptionCountUrl())
    .then(res => {
      console.log(res);
      dispatch(setActivePatientsCount(res?.data))
    }).catch(err => {
      console.log(err);
    }).finally(res => {
    })
  }
};

export const getConciergeServiceAction = () => {
  return (dispatch, getState) => {
    Axios.get(urls.getConciergeServiceUrl())
    .then(res => {
      console.log(res);
      dispatch(setConciergeServiceStatus(res?.data))
    }).catch(err => {
      console.log(err);
    }).finally(res => {
    })
  }
};